import WEALTH_DATA from './data/wealth.csv';

export default class Database {
    medianIncome: number;

    constructor() {
        this.medianIncome = 83000;
    }

    getPercentileForWealth(wealth) {
        for (let i = 0; i < WEALTH_DATA.length; i++) {
            const row = WEALTH_DATA[i];

            if (wealth >= row.wealth_cut) {
                return row.percentile;
            }
        }

        return 1;
    }
}
